/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_LeaderboardInputs */

const en_directory_vibebids_leaderboard = /** @type {(inputs: Directory_Vibebids_LeaderboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leaderboard`)
};

const zh_directory_vibebids_leaderboard = /** @type {(inputs: Directory_Vibebids_LeaderboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`实时榜单`)
};

/**
* | output |
* | --- |
* | "Leaderboard" |
*
* @param {Directory_Vibebids_LeaderboardInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_leaderboard = /** @type {((inputs?: Directory_Vibebids_LeaderboardInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_LeaderboardInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_leaderboard(inputs)
	return zh_directory_vibebids_leaderboard(inputs)
});
export { directory_vibebids_leaderboard as "directory.vibebids.leaderboard" }